export default __webpack_public_path__ + "static/media/stage_started.29771bc7.svg";